module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7eff27e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddNew.vue
// module id = 29
// module chunks = 0